import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import useAppStore from "@/context/store";
import { syncLead } from "@/services";
import { useMount } from "ahooks";
import { useRouter } from "next/router";

/**
 * 潜在线索自动推送
 */
export function useAutoPotentialCluesPush() {
  const { pathname } = useRouter();
  const user = useAppStore((store) => store.user);

  useMount(() => {
    // 没手机号不推送
    if (!user?.tel) {
      return;
    }

    const key = LOCAL_STORAGE_KEY.HB_AUTO_POTENTIAL_CLUES + pathname;
    const times = +localStorage.getItem(key) + 1;

    // 访问超过3次就推送
    if (times >= 3) {
      syncLead();
      // 上报后删除本地访问记录
      localStorage.removeItem(key);
    } else {
      // 记录页面访问次数
      localStorage.setItem(key, String(times));
    }
  });
}
